'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcon = require('@bibliocommons/base-icon');

var _baseIcon2 = _interopRequireDefault(_baseIcon);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdvisoryConstants = {
  GRAPHIC_VIOLENCE: 'GRAPHIC_VIOLENCE',
  OFFENSIVE_LANGUAGE: 'OFFENSIVE_LANGUAGE',
  SEXUAL_CONTENT: 'SEXUAL_CONTENT',
  FRIGHTENING_SCENES: 'FRIGHTENING_SCENES',
  OTHER: 'OTHER'
};

var ContentAdvisoryTypePicker = function (_BcReactComponent) {
  _inherits(ContentAdvisoryTypePicker, _BcReactComponent);

  function ContentAdvisoryTypePicker(props) {
    _classCallCheck(this, ContentAdvisoryTypePicker);

    var _this = _possibleConstructorReturn(this, (ContentAdvisoryTypePicker.__proto__ || Object.getPrototypeOf(ContentAdvisoryTypePicker)).call(this, props));

    _this.bindAll('renderContentTypes', 'handleSelect');
    return _this;
  }

  _createClass(ContentAdvisoryTypePicker, [{
    key: 'handleSelect',
    value: function handleSelect(value) {
      this.props.handleSelect(value);
    }
  }, {
    key: 'renderContentTypes',
    value: function renderContentTypes(option) {
      var _this2 = this;

      var _props = this.props,
          intl = _props.intl,
          advisories = _props.advisories,
          bibId = _props.bibId;

      var advisory = _lodash2.default.find(advisories, { type: option });
      if (advisory) {
        return _react2.default.createElement(
          'span',
          { className: 'list-group-item list-group-item-success' },
          _react2.default.createElement(
            'h3',
            { className: 'list-group-item-heading' },
            _react2.default.createElement(_baseIcon2.default, { icon: 'icon-check pull-right' }),
            _react2.default.createElement(_baseIcons.SVGIcon, { name: option }),
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: option.toLowerCase() + '_advisory_type' }),
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: 'content_advisory_added',
              values: {
                type: intl.formatMessage({ id: option.toLowerCase() + '_advisory_type' }),
                bibId: bibId,
                userContentId: advisory.userContentId
              } })
          )
        );
      }

      var handleSelect = function handleSelect() {
        _this2.props.handleSelect(option);
      };

      return _react2.default.createElement(
        _baseButtons.DefaultButton,
        { handleClick: handleSelect, className: 'list-group-item' },
        _react2.default.createElement(
          'h3',
          { className: 'list-group-item-heading' },
          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-angle-right pull-right' }),
          _react2.default.createElement(_baseIcons.SVGIcon, { name: option }),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: option.toLowerCase() + '_advisory_type' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-content-advisory-type-picker' },
        _react2.default.createElement(
          'div',
          { className: 'list-group' },
          _lodash2.default.map(AdvisoryConstants, this.renderContentTypes)
        )
      );
    }
  }]);

  return ContentAdvisoryTypePicker;
}(_baseBcReactComponent2.default);

ContentAdvisoryTypePicker.propTypes = {
  bibId: _react.PropTypes.number.isRequired,
  handleSelect: _react.PropTypes.func.isRequired,
  advisories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    type: _react.PropTypes.string,
    userContentId: _react.PropTypes.string
  })).isRequired,
  intl: _reactIntl.intlShape
};
exports.default = (0, _reactIntl.injectIntl)(ContentAdvisoryTypePicker);


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/content-advisory-type-picker/components/ContentAdvisoryTypePicker.js
// module id = 1020
// module chunks = 4